
<div class="search-filters"
[ngStyle]="{height: height+'px', width: width+'px', borderColor: color, borderRadius: radius+'px', backgroundColor: backgroundColor}"
>
    <mat-icon svgIcon="search"
    [ngStyle]="{color: color}"
    ></mat-icon>

    <input
    matInput
    autocomplete="off"
    id="search-filter-text"
    class="is-body2"
    type="text"
    placeholder="{{placeholder | translate}}"
    [(ngModel)]="searchedValue"
    [ngStyle]="{color: color, fontSize: fontSize}"
    (keyUp.enter)="emitSearch()"
    (focus)="clearPlaceholder()"
    (focusout)="this.placeholder=this.placeholderCopy"
    >

    <mat-icon
    *ngIf="searchedValue?.length > 0"
    [style.color]="color"
    class="clickable clear-input"
    (click)="clearInput()"
    svgIcon="close"
    ></mat-icon>

    <mat-icon
    *ngIf="showDropDown"
    class="clickable"
    (click)="togglePanel()"
    [ngStyle]="{transform: showpanel ? 'rotate(180deg)' : '', color: color}"
    svgIcon="arrow3_down"
    ></mat-icon>

    <div class="filter-panel" *ngIf="showpanel">

      <div class="content">
        <ng-content></ng-content>
      </div>

        <div class="button-container">

            <button
            *ngIf="showConfigure"
            color="primary"
            (click)="configureClicked()"
            mat-button
            >{{ configureText | translate }} </button>

            <div class="spacer"></div>

            <button
            (click)="cancelClicked()"
            mat-button
            >{{ cancelText | translate}}</button>

            <button
            (click)="saveClicked()"
            mat-button
            color="primary"
            >{{ saveText | translate}}</button>

        </div>
    </div>
   </div>